(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-bloom"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('.bp-root');
  if (!root) return;

  // Money formatter — uses Shopify global format if available
  const moneyFormat = window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : '${{amount}}';
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  // Thumbnail gallery
  const thumbs = root.querySelectorAll('[data-bp-thumb-index]');
  const slides = root.querySelectorAll('[data-bp-slide-index]');

  // Per-variant image filter: show only images whose data-bp-img-cat matches the selected variant's shape.
  // Runner SKU suffixes: 2610, 2612, 2670 → 'runner'. Everything else → 'area'. Overhead images always show.
  const RUNNER_SKUS = ['2610','2612','2670'];
  function _catForSku(sku) {
    if (!sku) return '';
    return RUNNER_SKUS.indexOf(String(sku)) !== -1 ? 'runner' : 'area';
  }
  function _hasAnyImgCats() {
    for (const s of slides) {
      const c = s.getAttribute('data-bp-img-cat');
      if (c === 'runner' || c === 'area') return true;
    }
    return false;
  }
  const _filterEnabled = _hasAnyImgCats();
  function _imgMatches(el, cat) {
    const c = el.getAttribute('data-bp-img-cat') || '';
    if (c === 'overhead' || c === '') return true; // overhead + unassigned always visible
    return c === cat;
  }
  function _findSkuForVid(vid) {
    if (!vid) return '';
    const btn = root.querySelector('[data-bp-variant-id="' + vid + '"]');
    return btn ? (btn.getAttribute('data-bp-variant-sku') || '') : '';
  }
  function applyVariantImageFilter(vid) {
    if (!_filterEnabled) return;
    const cat = _catForSku(_findSkuForVid(vid));
    if (!cat) return;
    slides.forEach(s => { s.style.display = _imgMatches(s, cat) ? '' : 'none'; });
    thumbs.forEach(t => { t.style.display = _imgMatches(t, cat) ? '' : 'none'; });
  }
  function firstVisibleSlideIndex() {
    for (const s of slides) {
      if (s.style.display !== 'none') return parseInt(s.getAttribute('data-bp-slide-index'), 10);
    }
    return 0;
  }

  function _visibleIdxList() {
    const out = [];
    slides.forEach(s => { if (s.style.display !== 'none') out.push(parseInt(s.getAttribute('data-bp-slide-index'), 10)); });
    return out;
  }
  function _stepVisible(fromIdx, dir) {
    const vis = _visibleIdxList();
    if (!vis.length) return fromIdx;
    const pos = vis.indexOf(fromIdx);
    if (pos === -1) return vis[0];
    return vis[(pos + dir + vis.length) % vis.length];
  }

  function goToSlide(i) {
    const idx = String(i);
    thumbs.forEach(x => {
      const on = x.getAttribute('data-bp-thumb-index') === idx;
      x.classList.toggle('is-active', on);
      x.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    slides.forEach(s => s.classList.toggle('is-active', s.getAttribute('data-bp-slide-index') === idx));
  }
  function currentSlideIndex() {
    for (const s of slides) {
      if (s.classList.contains('is-active')) return parseInt(s.getAttribute('data-bp-slide-index'), 10);
    }
    return 0;
  }
  thumbs.forEach(t => {
    t.addEventListener('click', () => goToSlide(t.getAttribute('data-bp-thumb-index')));
  });
  const arrowPrev = root.querySelector('[data-bp-arrow-prev]');
  const arrowNext = root.querySelector('[data-bp-arrow-next]');
  const total = slides.length;
  if (arrowPrev) arrowPrev.addEventListener('click', e => {
    e.stopPropagation();
    const i = currentSlideIndex();
    goToSlide(_stepVisible(i, -1));
  });
  if (arrowNext) arrowNext.addEventListener('click', e => {
    e.stopPropagation();
    const i = currentSlideIndex();
    goToSlide(_stepVisible(i, 1));
  });

  // Touch swipe on main image (finger-follow)
  const stage = root.querySelector('[data-bp-main-img]') || (slides[0] && slides[0].parentElement);
  if (stage && total > 1) {
    let sx = 0, sy = 0, sActive = false, sAxis = null;
    let curEl = null, prevEl = null, nextEl = null;

    function setActiveIndex(idx) {
      slides.forEach(s => s.classList.toggle('is-active', parseInt(s.getAttribute('data-bp-slide-index'), 10) === idx));
      thumbs.forEach(t => {
        const on = t.getAttribute('data-bp-thumb-index') === String(idx);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function clearSwipeStyles() {
      // Suppress transitions while clearing — must commit before restoring CSS
      [curEl, prevEl, nextEl].forEach(el => {
        if (!el) return;
        el.style.transition = 'none';
        el.style.transform = '';
        el.classList.remove('bp-swipe-show');
      });
      // Force reflow so the "no transition" state paints before CSS resumes
      void stage.offsetWidth;
      [curEl, prevEl, nextEl].forEach(el => {
        if (!el) return;
        el.style.transition = '';
      });
    }

    stage.addEventListener('touchstart', e => {
      if (e.touches.length !== 1) { sActive = false; return; }
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
      sActive = true;
      sAxis = null;
      curEl = null;
    }, { passive: true });

    stage.addEventListener('touchmove', e => {
      if (!sActive) return;
      const dx = e.touches[0].clientX - sx;
      const dy = e.touches[0].clientY - sy;
      if (!sAxis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        sAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (sAxis === 'x') {
          const i = currentSlideIndex();
          if (_visibleIdxList().length <= 1) { sAxis = 'y'; return; }
          curEl = slides[i];
          prevEl = slides[_stepVisible(i, -1)];
          nextEl = slides[_stepVisible(i, 1)];
          [curEl, prevEl, nextEl].forEach(el => { el.style.transition = 'none'; });
          prevEl.classList.add('bp-swipe-show');
          nextEl.classList.add('bp-swipe-show');
        }
      }
      if (sAxis === 'x') {
        e.preventDefault();
        curEl.style.transform = `translate3d(${dx}px, 0, 0)`;
        prevEl.style.transform = `translate3d(calc(-100% + ${dx}px), 0, 0)`;
        nextEl.style.transform = `translate3d(calc(100% + ${dx}px), 0, 0)`;
      }
    }, { passive: false });

    stage.addEventListener('touchend', e => {
      if (!sActive) return;
      sActive = false;
      if (sAxis !== 'x' || !curEl) { sAxis = null; return; }
      const dx = e.changedTouches[0].clientX - sx;
      const width = stage.offsetWidth || 1;
      const threshold = Math.min(80, width * 0.15);
      const tr = 'transform .22s ease-out';
      [curEl, prevEl, nextEl].forEach(el => { el.style.transition = tr; });

      if (Math.abs(dx) > threshold) {
        const dir = dx < 0 ? 1 : -1;
        const target = dir === 1 ? nextEl : prevEl;
        const off = dir === 1 ? '-100%' : '100%';
        curEl.style.transform = `translate3d(${off}, 0, 0)`;
        target.style.transform = 'translate3d(0, 0, 0)';
        const i = currentSlideIndex();
        const newIdx = _stepVisible(i, dir);
        setTimeout(() => {
          // Suppress all transitions, swap classes & clear inline styles, force reflow, then restore
          slides.forEach(s => { s.style.transition = 'none'; });
          setActiveIndex(newIdx);
          [curEl, prevEl, nextEl].forEach(el => {
            if (!el) return;
            el.style.transform = '';
            el.classList.remove('bp-swipe-show');
          });
          void stage.offsetWidth;
          slides.forEach(s => { s.style.transition = ''; });
        }, 230);
      } else {
        curEl.style.transform = 'translate3d(0, 0, 0)';
        prevEl.style.transform = 'translate3d(-100%, 0, 0)';
        nextEl.style.transform = 'translate3d(100%, 0, 0)';
        setTimeout(clearSwipeStyles, 230);
      }
      sAxis = null;
    });

    // Mouse drag (desktop swipe) — mirrors touch logic
    let mDown = false, mx = 0, my = 0, mAxis = null, mMoved = false;
    let mCurEl = null, mPrevEl = null, mNextEl = null;

    stage.addEventListener('mousedown', e => {
      if (e.button !== 0) return;
      if (e.target.closest('.bp-arrow')) return; // let arrow buttons work
      mDown = true;
      mx = e.clientX; my = e.clientY;
      mAxis = null; mMoved = false;
      mCurEl = null; mPrevEl = null; mNextEl = null;
      e.preventDefault();
    });

    document.addEventListener('mousemove', e => {
      if (!mDown) return;
      const dx = e.clientX - mx;
      const dy = e.clientY - my;
      if (!mAxis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        mAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (mAxis === 'x') {
          const i = currentSlideIndex();
          if (_visibleIdxList().length <= 1) { mAxis = 'y'; return; }
          mCurEl = slides[i];
          mPrevEl = slides[_stepVisible(i, -1)];
          mNextEl = slides[_stepVisible(i, 1)];
          [mCurEl, mPrevEl, mNextEl].forEach(el => { el.style.transition = 'none'; });
          mPrevEl.classList.add('bp-swipe-show');
          mNextEl.classList.add('bp-swipe-show');
          stage.classList.add('is-dragging');
        }
      }
      if (mAxis === 'x') {
        mMoved = true;
        mCurEl.style.transform = `translate3d(${dx}px, 0, 0)`;
        mPrevEl.style.transform = `translate3d(calc(-100% + ${dx}px), 0, 0)`;
        mNextEl.style.transform = `translate3d(calc(100% + ${dx}px), 0, 0)`;
      }
    });

    document.addEventListener('mouseup', e => {
      if (!mDown) return;
      mDown = false;
      stage.classList.remove('is-dragging');
      if (mAxis !== 'x' || !mCurEl) { mAxis = null; return; }
      const dx = e.clientX - mx;
      const width = stage.offsetWidth || 1;
      const threshold = Math.min(80, width * 0.15);
      const tr = 'transform .22s ease-out';
      [mCurEl, mPrevEl, mNextEl].forEach(el => { el.style.transition = tr; });

      // Suppress the click that follows the drag so lightbox doesn't open
      if (mMoved) {
        const swallow = ev => { ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation(); };
        stage.addEventListener('click', swallow, { capture: true, once: true });
        setTimeout(() => { stage.removeEventListener('click', swallow, { capture: true }); }, 50);
      }

      const cur = mCurEl, prev = mPrevEl, nxt = mNextEl;
      if (Math.abs(dx) > threshold) {
        const dir = dx < 0 ? 1 : -1;
        const target = dir === 1 ? nxt : prev;
        const off = dir === 1 ? '-100%' : '100%';
        cur.style.transform = `translate3d(${off}, 0, 0)`;
        target.style.transform = 'translate3d(0, 0, 0)';
        const i = currentSlideIndex();
        const newIdx = _stepVisible(i, dir);
        setTimeout(() => {
          slides.forEach(s => { s.style.transition = 'none'; });
          setActiveIndex(newIdx);
          [cur, prev, nxt].forEach(el => {
            if (!el) return;
            el.style.transform = '';
            el.classList.remove('bp-swipe-show');
          });
          void stage.offsetWidth;
          slides.forEach(s => { s.style.transition = ''; });
        }, 230);
      } else {
        cur.style.transform = 'translate3d(0, 0, 0)';
        prev.style.transform = 'translate3d(-100%, 0, 0)';
        nxt.style.transform = 'translate3d(100%, 0, 0)';
        setTimeout(() => {
          [cur, prev, nxt].forEach(el => {
            if (!el) return;
            el.style.transition = 'none';
            el.style.transform = '';
            el.classList.remove('bp-swipe-show');
          });
          void stage.offsetWidth;
          [cur, prev, nxt].forEach(el => { if (el) el.style.transition = ''; });
        }, 230);
      }
      mAxis = null;
      mCurEl = mPrevEl = mNextEl = null;
    });
  }

  // Lightbox
  const lb = root.querySelector('[data-bp-lightbox]');
  const lbStage = root.querySelector('[data-bp-lb-stage]');
  const lbImg = root.querySelector('[data-bp-lb-img]');
  const lbPrevImg = root.querySelector('[data-bp-lb-img-prev]');
  const lbNextImg = root.querySelector('[data-bp-lb-img-next]');
  const lbClose = root.querySelector('[data-bp-lb-close]');
  const lbPrev = root.querySelector('[data-bp-lb-prev]');
  const lbNext = root.querySelector('[data-bp-lb-next]');
  if (lb && lbImg) {
    const slideArr = Array.from(slides);
    let lbIndex = 0;

    function srcFor(el) { return el.getAttribute('data-bp-lb-src') || el.src; }

    function resetLbTransforms() {
      [lbImg, lbPrevImg, lbNextImg].forEach(el => {
        if (!el) return;
        el.style.transition = 'none';
        el.style.transform = '';
      });
      void (lbStage && lbStage.offsetWidth);
      [lbImg, lbPrevImg, lbNextImg].forEach(el => { if (el) el.style.transition = ''; });
    }

    function showLb(i) {
      const len = slideArr.length;
      if (i < 0) i = len - 1;
      if (i >= len) i = 0;
      lbIndex = i;
      const cur = slideArr[i];
      const prev = slideArr[(i - 1 + len) % len];
      const next = slideArr[(i + 1) % len];
      lbImg.src = srcFor(cur);
      lbImg.alt = cur.alt || '';
      if (lbPrevImg) { lbPrevImg.src = srcFor(prev); lbPrevImg.alt = prev.alt || ''; }
      if (lbNextImg) { lbNextImg.src = srcFor(next); lbNextImg.alt = next.alt || ''; }
      resetLbTransforms();
    }
    function openLb(i) {
      showLb(i);
      lb.classList.add('is-open');
      lb.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bp-lb-open');
    }
    function closeLb() {
      lb.classList.remove('is-open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('bp-lb-open');
    }
    slideArr.forEach((s, i) => {
      s.addEventListener('click', () => openLb(i));
    });
    lbClose && lbClose.addEventListener('click', closeLb);
    lbPrev && lbPrev.addEventListener('click', e => { e.stopPropagation(); showLb(lbIndex - 1); });
    lbNext && lbNext.addEventListener('click', e => { e.stopPropagation(); showLb(lbIndex + 1); });
    lb.addEventListener('click', e => { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', e => {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowLeft') showLb(lbIndex - 1);
      else if (e.key === 'ArrowRight') showLb(lbIndex + 1);
    });

    // Touch swipe inside lightbox (finger-follow)
    if (lbStage) {
      let lx = 0, ly = 0, lActive = false, lAxis = null;
      lbStage.addEventListener('touchstart', e => {
        if (e.touches.length !== 1) { lActive = false; return; }
        lx = e.touches[0].clientX;
        ly = e.touches[0].clientY;
        lActive = true;
        lAxis = null;
      }, { passive: true });

      lbStage.addEventListener('touchmove', e => {
        if (!lActive) return;
        const dx = e.touches[0].clientX - lx;
        const dy = e.touches[0].clientY - ly;
        if (!lAxis) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          lAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (lAxis === 'x') {
            [lbImg, lbPrevImg, lbNextImg].forEach(el => { if (el) el.style.transition = 'none'; });
          }
        }
        if (lAxis === 'x') {
          e.preventDefault();
          lbImg.style.transform = `translate3d(${dx}px, 0, 0)`;
          if (lbPrevImg) lbPrevImg.style.transform = `translate3d(calc(-100% + ${dx}px), 0, 0)`;
          if (lbNextImg) lbNextImg.style.transform = `translate3d(calc(100% + ${dx}px), 0, 0)`;
        }
      }, { passive: false });

      lbStage.addEventListener('touchend', e => {
        if (!lActive) return;
        lActive = false;
        if (lAxis !== 'x') { lAxis = null; return; }
        const dx = e.changedTouches[0].clientX - lx;
        const width = lbStage.offsetWidth || 1;
        const threshold = Math.min(80, width * 0.15);
        const tr = 'transform .22s ease-out';
        [lbImg, lbPrevImg, lbNextImg].forEach(el => { if (el) el.style.transition = tr; });

        if (Math.abs(dx) > threshold) {
          const dir = dx < 0 ? 1 : -1;
          const off = dir === 1 ? '-100%' : '100%';
          lbImg.style.transform = `translate3d(${off}, 0, 0)`;
          if (dir === 1 && lbNextImg) lbNextImg.style.transform = 'translate3d(0, 0, 0)';
          if (dir === -1 && lbPrevImg) lbPrevImg.style.transform = 'translate3d(0, 0, 0)';
          setTimeout(() => { showLb(lbIndex + dir); }, 230);
        } else {
          lbImg.style.transform = 'translate3d(0, 0, 0)';
          if (lbPrevImg) lbPrevImg.style.transform = 'translate3d(-100%, 0, 0)';
          if (lbNextImg) lbNextImg.style.transform = 'translate3d(100%, 0, 0)';
        }
        lAxis = null;
      });

      // Mouse drag in lightbox
      let lmDown = false, lmx = 0, lmy = 0, lmAxis = null, lmMoved = false;

      lbStage.addEventListener('mousedown', e => {
        if (e.button !== 0) return;
        if (e.target.closest('.bp-lb-nav, .bp-lb-close')) return;
        lmDown = true;
        lmx = e.clientX; lmy = e.clientY;
        lmAxis = null; lmMoved = false;
        e.preventDefault();
      });

      document.addEventListener('mousemove', e => {
        if (!lmDown) return;
        const dx = e.clientX - lmx;
        const dy = e.clientY - lmy;
        if (!lmAxis) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          lmAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (lmAxis === 'x') {
            [lbImg, lbPrevImg, lbNextImg].forEach(el => { if (el) el.style.transition = 'none'; });
            lbStage.classList.add('is-dragging');
          }
        }
        if (lmAxis === 'x') {
          lmMoved = true;
          lbImg.style.transform = `translate3d(${dx}px, 0, 0)`;
          if (lbPrevImg) lbPrevImg.style.transform = `translate3d(calc(-100% + ${dx}px), 0, 0)`;
          if (lbNextImg) lbNextImg.style.transform = `translate3d(calc(100% + ${dx}px), 0, 0)`;
        }
      });

      document.addEventListener('mouseup', e => {
        if (!lmDown) return;
        lmDown = false;
        lbStage.classList.remove('is-dragging');
        if (lmAxis !== 'x') { lmAxis = null; return; }
        const dx = e.clientX - lmx;
        const width = lbStage.offsetWidth || 1;
        const threshold = Math.min(80, width * 0.15);
        const tr = 'transform .22s ease-out';
        [lbImg, lbPrevImg, lbNextImg].forEach(el => { if (el) el.style.transition = tr; });

        if (Math.abs(dx) > threshold) {
          const dir = dx < 0 ? 1 : -1;
          const off = dir === 1 ? '-100%' : '100%';
          lbImg.style.transform = `translate3d(${off}, 0, 0)`;
          if (dir === 1 && lbNextImg) lbNextImg.style.transform = 'translate3d(0, 0, 0)';
          if (dir === -1 && lbPrevImg) lbPrevImg.style.transform = 'translate3d(0, 0, 0)';
          setTimeout(() => { showLb(lbIndex + dir); }, 230);
        } else {
          lbImg.style.transform = 'translate3d(0, 0, 0)';
          if (lbPrevImg) lbPrevImg.style.transform = 'translate3d(-100%, 0, 0)';
          if (lbNextImg) lbNextImg.style.transform = 'translate3d(100%, 0, 0)';
        }
        lmAxis = null;
      });
    }
  }

  // Variant (size) selection
  const sizes = root.querySelectorAll('[data-bp-size]');
  const variantInput = root.querySelector('[data-bp-variant-input]');
  // Apply initial variant filter on load
  if (_filterEnabled && variantInput && variantInput.value) {
    applyVariantImageFilter(variantInput.value);
    const _firstVis = firstVisibleSlideIndex();
    if (_firstVis !== 0) {
      slides.forEach(s => s.classList.toggle('is-active', parseInt(s.getAttribute('data-bp-slide-index'),10) === _firstVis));
      thumbs.forEach(t => t.classList.toggle('is-active', parseInt(t.getAttribute('data-bp-thumb-index'),10) === _firstVis));
    }
  }
  const sizeLabel = root.querySelector('[data-bp-size-label]');
  const priceNow = root.querySelector('[data-bp-price-now]');
  const priceWas = root.querySelector('[data-bp-price-was]');
  const priceSize = root.querySelector('[data-bp-price-size]');
  const addPrice = root.querySelector('[data-bp-add-price]');
  const addBtn = root.querySelector('[data-bp-add]');
  const priceWrap = root.querySelector('[data-bp-price]');

  // ---- Sold-out handling: ATC vs "Notify me when back in stock" ----
  const shipNote = root.querySelector('[data-bp-ship-note]');
  const notifyWrap = root.querySelector('[data-bp-notify]');
  const notifyOpen = root.querySelector('[data-bp-notify-open]');
  const notifyHint = root.querySelector('[data-bp-notify-hint]');
  const notifyForm = root.querySelector('[data-bp-notify-form]');
  const notifyEmail = root.querySelector('[data-bp-notify-email]');
  const notifySubmit = root.querySelector('[data-bp-notify-submit]');
  const notifyMsg = root.querySelector('[data-bp-notify-msg]');
  const notifyDone = root.querySelector('[data-bp-notify-done]');
  const notifySize = root.querySelector('[data-bp-notify-size]');
  const KLAVIYO_COMPANY = 'XYkgDv';
  let notifyBusy = false;

  function isVariantAvailable(vid) {
    const b = root.querySelector('[data-bp-size][data-bp-variant-id="' + vid + '"]');
    // No size buttons (simple mode) → trust server-rendered state
    return b ? b.getAttribute('data-bp-variant-available') === 'true' : (addBtn ? addBtn.style.display !== 'none' : true);
  }
  function resetNotify() {
    if (notifyForm) notifyForm.style.display = 'none';
    if (notifyDone) notifyDone.style.display = 'none';
    if (notifyOpen) notifyOpen.style.display = '';
    if (notifyHint) notifyHint.style.display = '';
    if (notifyMsg) { notifyMsg.textContent = ''; notifyMsg.className = 'bp-notify-msg'; }
    if (notifySubmit) notifySubmit.disabled = false;
    notifyBusy = false;
  }
  function setPurchasable(available, title) {
    if (addBtn) addBtn.style.display = available ? '' : 'none';
    if (shipNote) shipNote.style.display = available ? '' : 'none';
    if (notifyWrap) notifyWrap.style.display = available ? 'none' : '';
    if (!available) {
      resetNotify();
      if (notifySize && title) notifySize.textContent = title;
    }
  }
  function syncOosTag(btn, available) {
    let tag = btn.querySelector('.bp-size-oos');
    if (!available && !tag) {
      tag = document.createElement('span');
      tag.className = 'bp-size-oos';
      tag.textContent = 'Sold out';
      btn.appendChild(tag);
    } else if (available && tag) {
      tag.remove();
    }
  }
  if (notifyOpen) {
    notifyOpen.addEventListener('click', () => {
      notifyOpen.style.display = 'none';
      if (notifyHint) notifyHint.style.display = 'none';
      if (notifyForm) notifyForm.style.display = '';
      if (notifyEmail) { try { notifyEmail.focus(); } catch (e) {} }
    });
  }
  async function submitNotify() {
    if (notifyBusy) return;
    const email = (notifyEmail && notifyEmail.value || '').trim();
    const vid = variantInput ? variantInput.value : '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (notifyMsg) { notifyMsg.textContent = 'Please enter a valid email address.'; notifyMsg.className = 'bp-notify-msg is-err'; }
      if (notifyEmail) notifyEmail.focus();
      return;
    }
    if (!vid) {
      if (notifyMsg) { notifyMsg.textContent = 'Something went wrong. Please refresh and try again.'; notifyMsg.className = 'bp-notify-msg is-err'; }
      return;
    }
    notifyBusy = true;
    if (notifySubmit) notifySubmit.disabled = true;
    if (notifyMsg) { notifyMsg.textContent = ''; notifyMsg.className = 'bp-notify-msg'; }
    try {
      const r = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY, {
        method: 'POST',
        headers: { 'revision': '2025-07-15', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } },
              channels: ['EMAIL']
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } }
            }
          }
        })
      });
      if (r.status === 202 || r.ok) {
        if (notifyForm) notifyForm.style.display = 'none';
        if (notifyDone) notifyDone.style.display = '';
      } else {
        throw new Error('status ' + r.status);
      }
    } catch (err) {
      console.error('[bp-notify] subscribe failed', err);
      if (notifyMsg) { notifyMsg.textContent = "We couldn't save that. Please check your email and try again."; notifyMsg.className = 'bp-notify-msg is-err'; }
    } finally {
      notifyBusy = false;
      if (notifySubmit) notifySubmit.disabled = false;
    }
  }
  if (notifySubmit) notifySubmit.addEventListener('click', submitNotify);
  if (notifyEmail) {
    // The input lives inside the cart form — Enter must not add to cart
    notifyEmail.addEventListener('keydown', e => {
      if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); submitNotify(); }
    });
  }

  sizes.forEach(s => {
    s.addEventListener('click', () => {
      if (s.classList.contains('is-placeholder') || s.disabled) return;
      const available = s.getAttribute('data-bp-variant-available') === 'true';
      sizes.forEach(x => {
        x.classList.toggle('is-active', x === s);
        x.setAttribute('aria-checked', x === s ? 'true' : 'false');
      });
      const vid = s.getAttribute('data-bp-variant-id');
      applyVariantImageFilter(vid);
      goToSlide(firstVisibleSlideIndex());
      const title = s.getAttribute('data-bp-variant-title');
      const price = parseInt(s.getAttribute('data-bp-variant-price'), 10);
      const compare = parseInt(s.getAttribute('data-bp-variant-compare'), 10);

      variantInput.value = vid;
      sizeLabel.textContent = title;
      priceNow.textContent = formatMoney(price);
      priceSize.textContent = '· ' + title;
      addPrice.textContent = formatMoney(price);
      setPurchasable(available, title);

      if (compare && compare > price) {
        if (!priceWas) {
          const w = document.createElement('span');
          w.className = 'bp-price-was';
          w.setAttribute('data-bp-price-was', '');
          w.textContent = formatMoney(compare);
          priceWrap.insertBefore(w, priceSize);
        } else {
          priceWas.textContent = formatMoney(compare);
          priceWas.style.display = '';
        }
      } else if (priceWas) {
        priceWas.style.display = 'none';
      }

      // Sync URL so it survives refresh
      try {
        const url = new URL(window.location);
        url.searchParams.set('variant', vid);
        window.history.replaceState({}, '', url);
      } catch (e) {}
    });
  });

  // Cross-product color swatches — in-place swap, no page reload
  const colorBtns = root.querySelectorAll('[data-bp-color-handle]');
  let siblingsData = null;
  const siblingsScript = document.getElementById('bp-siblings-data');
  if (siblingsScript) {
    try { siblingsData = JSON.parse(siblingsScript.textContent); } catch (e) { siblingsData = null; }
  }

  function findSibling(handle) {
    if (!siblingsData) return null;
    return siblingsData.find(s => s.handle === handle) || null;
  }

  function swapToSibling(handle) {
    const data = findSibling(handle);
    if (!data) return false;

    // Capture currently selected size BEFORE we mutate buttons
    const activeSize = root.querySelector('.bp-size.is-active');
    const wantSize = activeSize ? activeSize.getAttribute('data-bp-variant-size') : null;

    // 1. Root attributes
    root.setAttribute('data-product-id', data.productId);
    root.setAttribute('data-product-handle', data.handle);

    // 2. Titles (mobile + desktop)
    root.querySelectorAll('[data-bp-title]').forEach(el => { el.textContent = data.title; });
    document.querySelectorAll('[data-bp-crumb-title]').forEach(el => { el.textContent = data.title; });

    // 3. Color label (mobile + desktop)
    root.querySelectorAll('[data-bp-color-label]').forEach(el => { el.textContent = '· ' + data.colorLabel; });
    const descLabel = root.querySelector('.bp-details .bp-opt-value');
    // (mobile head has data-bp-color-label; desktop header is the second .bp-opt-value above the swatches)

    // 4. Description
    const descBody = root.querySelector('[data-bp-description]');
    if (descBody) descBody.innerHTML = data.description || '';

    // 5. Active swatch
    colorBtns.forEach(b => {
      const isCur = b.getAttribute('data-bp-color-handle') === handle;
      b.classList.toggle('is-active', isCur);
      b.setAttribute('aria-checked', isCur ? 'true' : 'false');
      if (isCur) b.setAttribute('data-bp-color-current', ''); else b.removeAttribute('data-bp-color-current');
    });

    // 6. Gallery thumbs + slides
    const thumbImgs = root.querySelectorAll('[data-bp-thumb-img]');
    thumbImgs.forEach((img, i) => {
      const t = data.thumbs[i];
      if (!t) return;
      img.src = t.src;
      img.alt = t.alt;
    });
    const slideEls = root.querySelectorAll('.bp-slide');
    slideEls.forEach((img, i) => {
      const s = data.slides[i];
      if (!s) return;
      img.src = s.src;
      img.srcset = `${s.srcset700} 700w, ${s.srcset1100} 1100w, ${s.srcset1400} 1400w`;
      img.setAttribute('data-bp-lb-src', s.lbSrc);
      img.alt = s.alt;
    });
    // Reset to slide 0 + thumb 0
    slideEls.forEach((s, i) => s.classList.toggle('is-active', i === 0));
    root.querySelectorAll('.bp-thumb').forEach((t, i) => {
      t.classList.toggle('is-active', i === 0);
      t.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
    });

    // 7. Lifestyle image
    const ls = root.querySelector('[data-bp-lifestyle-img]');
    if (ls && data.lifestyle) {
      ls.src = data.lifestyle.src;
      ls.srcset = data.lifestyle.srcset;
      ls.alt = data.title + ' in a styled room';
    }

    // 8. Size buttons — rebind to new product's variants
    const sizeBtns = root.querySelectorAll('[data-bp-size]');
    sizeBtns.forEach(s => {
      const sz = s.getAttribute('data-bp-variant-size');
      const v = sz && data.variantsBySize[sz];
      if (!v) {
        s.classList.add('is-oos');
        s.setAttribute('data-bp-variant-available', 'false');
        syncOosTag(s, false);
        return;
      }
      s.setAttribute('data-bp-variant-id', v.id);
      s.setAttribute('data-bp-variant-price', v.price);
      s.setAttribute('data-bp-variant-compare', v.compare || 0);
      s.setAttribute('data-bp-variant-available', v.available ? 'true' : 'false');
      s.classList.toggle('is-oos', !v.available);
      syncOosTag(s, !!v.available);
    });

    // 9. Pick target variant matching previously selected size (or first available)
    let target = wantSize && data.variantsBySize[wantSize];
    if (!target || !target.available) {
      // pick first available
      for (const k in data.variantsBySize) {
        if (data.variantsBySize[k].available) { target = data.variantsBySize[k]; break; }
      }
    }
    if (target) {
      // Apply via simulated click on the matching size button
      const match = Array.from(sizeBtns).find(b => parseInt(b.getAttribute('data-bp-variant-id'), 10) === target.id);
      if (match) {
        sizeBtns.forEach(x => {
          x.classList.toggle('is-active', x === match);
          x.setAttribute('aria-checked', x === match ? 'true' : 'false');
        });
        if (variantInput) variantInput.value = target.id;
        if (sizeLabel) sizeLabel.textContent = match.getAttribute('data-bp-variant-title');
        if (priceNow) priceNow.textContent = formatMoney(target.price);
        if (priceSize) priceSize.textContent = '· ' + match.getAttribute('data-bp-variant-title');
        if (addPrice) addPrice.textContent = formatMoney(target.price);
        setPurchasable(!!target.available, match.getAttribute('data-bp-variant-title'));
        const existingWas = root.querySelector('[data-bp-price-was]');
        if (target.compare && target.compare > target.price) {
          if (!existingWas) {
            const w = document.createElement('span');
            w.className = 'bp-price-was';
            w.setAttribute('data-bp-price-was', '');
            w.textContent = formatMoney(target.compare);
            priceWrap.insertBefore(w, priceSize);
          } else {
            existingWas.textContent = formatMoney(target.compare);
            existingWas.style.display = '';
          }
        } else if (existingWas) {
          existingWas.style.display = 'none';
        }
      }
    }

    // 10. Stars block(s)
    root.querySelectorAll('[data-bp-stars]').forEach(box => {
      if (data.reviewCount && data.reviewCount > 0) {
        box.hidden = false;
        box.innerHTML =
          '<div data-oke-star-rating data-oke-reviews-product-id="shopify-' + data.productId + '">' +
          data.starsHtml +
          '</div>' +
          '<a href="#bp-reviews" class="bp-stars-link">(<span>' + data.reviewCount + ' Reviews</span>)</a>';
      } else {
        box.hidden = true;
        box.innerHTML = '';
      }
    });
    // Replace the main reviews widget element with a fresh node for the new product,
    // then force-reload Okendo's script tag so it hydrates the new element.
    document.querySelectorAll('[data-oke-widget]').forEach(w => {
      const fresh = document.createElement('div');
      for (const attr of w.attributes) {
        if (attr.name === 'data-oke-reviews-product-id') continue;
        fresh.setAttribute(attr.name, attr.value);
      }
      fresh.setAttribute('data-oke-reviews-product-id', 'shopify-' + data.productId);
      w.parentNode.replaceChild(fresh, w);
    });

    // Reload Okendo widget scripts so their init code processes the new element
    document.querySelectorAll('script[src*="okendo" i], script[src*="oke-" i]').forEach(s => {
      const clone = document.createElement('script');
      for (const attr of s.attributes) clone.setAttribute(attr.name, attr.value);
      // Cache-bust to force re-execution
      const sep = clone.src.includes('?') ? '&' : '?';
      clone.src = clone.src + sep + '_bp=' + Date.now();
      clone.async = true;
      s.parentNode.replaceChild(clone, s);
    });

    // Also try API calls in case the script self-initialized previously
    try {
      if (window.okeWidgetApi && typeof window.okeWidgetApi.initWidgets === 'function') {
        window.okeWidgetApi.initWidgets();
      }
    } catch (e) {}

    // 11. Favorite button state — keyed on product id
    const favs = root.querySelectorAll('[data-bp-fav], [data-bp-fav-mobile]');
    if (favs.length) {
      const pid = String(data.productId);
      const key = 'bp-fav-' + pid;
      const isFav = localStorage.getItem(key) === '1';
      favs.forEach(b => b.setAttribute('aria-pressed', isFav ? 'true' : 'false'));
    }

    // 12. URL — preserve scroll, no reload
    const newUrl = data.url + (target ? '?variant=' + target.id : '');
    try { window.history.pushState({ bpHandle: handle }, '', newUrl); } catch (e) {}

    // 12b. Reload customers-also-viewed recs for the new product
    if (typeof window._bpReloadRecs === 'function') window._bpReloadRecs(data.productId);

    // 13. Reset main gallery transforms (in case mid-swipe state lingers)
    root.querySelectorAll('.bp-slide').forEach(s => {
      s.style.transform = '';
      s.style.transition = '';
      s.classList.remove('bp-swipe-show');
    });

    return true;
  }

  colorBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.hasAttribute('data-bp-color-current')) return;
      const handle = btn.getAttribute('data-bp-color-handle');
      const ok = swapToSibling(handle);
      if (!ok) {
        // Fallback to full nav if data missing
        let variantsList = [];
        try { variantsList = JSON.parse(btn.getAttribute('data-bp-color-variants') || '[]'); } catch (e) {}
        const activeSize = root.querySelector('.bp-size.is-active');
        const wantSize = activeSize ? activeSize.getAttribute('data-bp-variant-size') : null;
        let target = wantSize ? variantsList.find(v => v.size === wantSize) : null;
        if (!target && variantsList.length) target = variantsList[0];
        window.location.href = target ? `/products/${handle}?variant=${target.id}` : `/products/${handle}`;
      }
    });
  });

  // Browser back/forward across swapped colors
  window.addEventListener('popstate', e => {
    const m = window.location.pathname.match(/\/products\/([^/?]+)/);
    if (m && m[1] !== root.getAttribute('data-product-handle')) {
      const handle = m[1];
      if (findSibling(handle)) swapToSibling(handle);
      else window.location.reload();
    }
  });

  // Size guide button (placeholder - opens nothing yet)
  const sgBtn = root.querySelector('[data-bp-open-size-guide]');
  if (sgBtn) sgBtn.addEventListener('click', () => alert('Size guide coming soon.'));

  // Favorite toggle (localStorage) — desktop + mobile buttons stay in sync.
  // Also persist the product handle in 'bp-fav-handles' so /pages/favorite-rugs
  // can resolve product ids back to handles for /products/<handle>.js lookups.
  const favs = root.querySelectorAll('[data-bp-fav], [data-bp-fav-mobile]');
  if (favs.length) {
    const pid = root.getAttribute('data-product-id');
    const phandle = root.getAttribute('data-product-handle') || (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || '';
    const key = 'bp-fav-' + pid;
    const HANDLE_MAP_KEY = 'bp-fav-handles';
    function readMap() {
      try { return JSON.parse(localStorage.getItem(HANDLE_MAP_KEY) || '{}') || {}; }
      catch (e) { return {}; }
    }
    function writeMap(m) {
      try { localStorage.setItem(HANDLE_MAP_KEY, JSON.stringify(m)); } catch (e) {}
    }
    const initial = localStorage.getItem(key) === '1';
    favs.forEach(b => b.setAttribute('aria-pressed', initial ? 'true' : 'false'));
    // If already favorited and we just learned a fresh handle, refresh the map
    if (initial && phandle) {
      const m = readMap(); if (m[pid] !== phandle) { m[pid] = phandle; writeMap(m); }
    }
    favs.forEach(b => {
      b.addEventListener('click', () => {
        // Re-read product id/handle from the DOM at click time — the user may have
        // swapped to a sibling color variant since the page loaded, in which case
        // root's data-product-id / data-product-handle have been updated.
        const curPid = root.getAttribute('data-product-id') || pid;
        const curHandle = root.getAttribute('data-product-handle')
          || (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || phandle;
        const curKey = 'bp-fav-' + curPid;
        const pressed = b.getAttribute('aria-pressed') === 'true';
        const next = !pressed;
        favs.forEach(x => x.setAttribute('aria-pressed', next ? 'true' : 'false'));
        const m = readMap();
        if (next) {
          localStorage.setItem(curKey, '1');
          if (curHandle) { m[curPid] = curHandle; writeMap(m); }
        } else {
          localStorage.removeItem(curKey);
          delete m[curPid]; writeMap(m);
        }
        if (window.BloomFav && typeof window.BloomFav.refreshCount === 'function') {
          window.BloomFav.refreshCount();
        }
      });
    });
  }

  // JS sticky via transform — keeps gallery in its grid slot, just shifts visually
  const layout = root.querySelector('.bp-layout');
  const gallery = root.querySelector('.bp-gallery');
  const details = root.querySelector('.bp-details');
  if (layout && gallery && details) {
    /* Clearance above the pinned gallery. The header is sticky site-wide as of
       2026-09-16, so a flat 24px would have slid the gallery underneath it -
       measure the sticky region each time instead (its height changes with
       viewport width) and fall back to the original 24px whenever the header is
       not sticky, so this keeps working if that setting is ever turned off. */
    function topGap() {
      const sh = document.querySelector('.section-header');
      if (!sh) return 24;
      const pos = getComputedStyle(sh).position;
      if (pos !== 'sticky' && pos !== '-webkit-sticky') return 24;
      return Math.round(sh.getBoundingClientRect().height) + 24;
    }

    function update() {
      const TOP = topGap();
      if (window.innerWidth <= 900) {
        gallery.style.transform = '';
        return;
      }
      const layoutRect = layout.getBoundingClientRect();
      const galleryH = gallery.offsetHeight;
      const detailsH = details.offsetHeight;

      let shift = 0;
      if (layoutRect.top < TOP) {
        shift = TOP - layoutRect.top;
        const maxShift = Math.max(0, detailsH - galleryH);
        if (shift > maxShift) shift = maxShift;
      }
      gallery.style.transform = shift > 0 ? 'translateY(' + shift + 'px)' : '';
    }

    let ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => { update(); ticking = false; });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    setTimeout(update, 100);
    window.addEventListener('load', update);
  }

  // ---------- Customers Also Viewed ----------
  const recsSection = document.querySelector('[data-bp-recs]');
  if (recsSection) {
    const productId = recsSection.getAttribute('data-product-id');
    const track = recsSection.querySelector('[data-bp-recs-track]');
    const prevBtn = recsSection.querySelector('[data-bp-recs-prev]');
    const nextBtn = recsSection.querySelector('[data-bp-recs-next]');

    function formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function renderVibe(products) {
      const grid = document.querySelector('[data-bp-vibe-grid]');
      if (!grid) return;
      grid.innerHTML = '';
      products.forEach(p => {
        const a = document.createElement('a');
        a.className = 'bp-color';
        a.href = p.url || ('/products/' + p.handle);
        const cleanTitle = (p.title || '').split(' Rug')[0].split(' Washable')[0];
        a.setAttribute('aria-label', p.title || '');
        let src = p.featured_image || (p.images && p.images[0]) || '';
        if (src && typeof src === 'object') src = src.src || '';
        const span = document.createElement('span');
        span.className = 'bp-swatch';
        if (src) {
          const sized = src.replace(/(\.(?:jpg|jpeg|png|webp))(\?|$)/i, '_240x$1$2');
          span.style.backgroundImage = "url('" + sized + "')";
          const big = src.replace(/(\.(?:jpg|jpeg|png|webp))(\?|$)/i, '_600x$1$2');
          a.dataset.vibeImg = big;
          a.dataset.vibeTitle = cleanTitle;
        }
        a.appendChild(span);
        grid.appendChild(a);
      });
      attachVibePopup(grid);
      if (window._bpUpdateVibeArrows) window._bpUpdateVibeArrows();
    }

    function attachVibePopup(grid) {
      if (window.matchMedia('(hover: none), (max-width: 700px)').matches) return;
      let pop = document.querySelector('.bp-vibe-pop');
      if (!pop) {
        pop = document.createElement('div');
        pop.className = 'bp-vibe-pop';
        pop.innerHTML = '<img class="bp-vibe-pop-img" alt=""><div class="bp-vibe-pop-title"></div>';
        document.body.appendChild(pop);
      }
      const imgEl = pop.querySelector('.bp-vibe-pop-img');
      const titleEl = pop.querySelector('.bp-vibe-pop-title');
      let hoverTimer = null;

      grid.querySelectorAll('a.bp-color[data-vibe-img]').forEach(el => {
        el.addEventListener('mouseenter', () => {
          clearTimeout(hoverTimer);
          imgEl.src = el.dataset.vibeImg;
          titleEl.textContent = el.dataset.vibeTitle || '';
          const rect = el.getBoundingClientRect();
          pop.style.left = (rect.left + rect.width / 2 + window.scrollX) + 'px';
          pop.style.top = (rect.top + window.scrollY - 12) + 'px';
          pop.classList.add('is-visible');
        });
        el.addEventListener('mouseleave', () => {
          hoverTimer = setTimeout(() => pop.classList.remove('is-visible'), 80);
        });
      });
    }

    function renderCards(products) {
      track.innerHTML = '';
      products.forEach(p => {
        const a = document.createElement('a');
        a.className = 'bp-recs-card';
        a.href = p.url || ('/products/' + p.handle);
        const imgWrap = document.createElement('div');
        imgWrap.className = 'bp-recs-card-img';
        const img = document.createElement('img');
        img.loading = 'lazy';
        img.alt = p.title || '';
        let src = p.featured_image || (p.images && p.images[0]) || '';
        if (src && typeof src === 'object') src = src.src || '';
        if (src) {
          img.src = src.replace(/(\.(?:jpg|jpeg|png|webp))(\?|$)/i, '_600x$1$2');
          img.srcset = [300, 600, 900].map(w =>
            src.replace(/(\.(?:jpg|jpeg|png|webp))(\?|$)/i, '_' + w + 'x$1$2') + ' ' + w + 'w'
          ).join(', ');
          img.sizes = '(max-width: 900px) 50vw, 16vw';
        }
        imgWrap.appendChild(img);
        const cleanTitle = (p.title || '').split(' Rug')[0].split(' Washable')[0];
        const title = document.createElement('div');
        title.className = 'bp-recs-card-title';
        title.textContent = cleanTitle;
        const price = document.createElement('div');
        price.className = 'bp-recs-card-price';
        const priceCents = (typeof p.price === 'number') ? p.price : (parseFloat(p.price) * 100);
        if (!isNaN(priceCents)) price.textContent = 'From ' + formatMoney(priceCents);
        a.appendChild(imgWrap);
        a.appendChild(title);
        a.appendChild(price);
        track.appendChild(a);
      });
      updateArrows();
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      const maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 2;
    }

    function scrollByPage(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', () => scrollByPage(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => scrollByPage(1));
    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(updateArrows);
    }, { passive: true });

    // ---------- Vibe carousel arrows ----------
    const vibeSection = document.querySelector('[data-bp-vibe]');
    if (vibeSection) {
      const vibeTrack = vibeSection.querySelector('[data-bp-vibe-grid]');
      const vibePrev = vibeSection.querySelector('[data-bp-vibe-prev]');
      const vibeNext = vibeSection.querySelector('[data-bp-vibe-next]');
      function updateVibeArrows() {
        if (!vibePrev || !vibeNext || !vibeTrack) return;
        const maxScroll = vibeTrack.scrollWidth - vibeTrack.clientWidth;
        vibePrev.disabled = vibeTrack.scrollLeft <= 2;
        vibeNext.disabled = vibeTrack.scrollLeft >= maxScroll - 2;
      }
      function scrollVibe(dir) {
        vibeTrack.scrollBy({ left: dir * vibeTrack.clientWidth, behavior: 'smooth' });
      }
      if (vibePrev) vibePrev.addEventListener('click', () => scrollVibe(-1));
      if (vibeNext) vibeNext.addEventListener('click', () => scrollVibe(1));
      vibeTrack.addEventListener('scroll', () => {
        window.requestAnimationFrame(updateVibeArrows);
      }, { passive: true });
      // Expose so renderVibe can call after population
      window._bpUpdateVibeArrows = updateVibeArrows;
    }

    // Fetch recommendations, then top up from the continuing-design collection to fill 18 vibe slots.
    // Only products in VIBE_ALLOW_COLLECTION (= the 46 continuing designs) may appear here —
    // discontinued designs that are still active in Shopify must never show in "Designs With Similar Vibe".
    const VIBE_ALLOW_COLLECTION = 'best-sellers';
    function loadRecs(pid) {
      const recsP = fetch('/recommendations/products.json?product_id=' + pid + '&limit=18&intent=related')
        .then(r => r.ok ? r.json() : { products: [] })
        .then(d => d.products || [])
        .catch(() => []);

      const allP = fetch('/collections/' + VIBE_ALLOW_COLLECTION + '/products.json?limit=250')
        .then(r => r.ok ? r.json() : { products: [] })
        .then(d => (d.products || []).filter(p => String(p.id) !== String(pid)).map(p => ({
          id: p.id,
          title: p.title,
          handle: p.handle,
          featured_image: p.images && p.images[0] && p.images[0].src,
          price: parseFloat(p.variants[0].price) * 100,
          url: '/products/' + p.handle
        })))
        .catch(() => []);

      Promise.all([recsP, allP]).then(([recs, all]) => {
        // Allowlist = continuing designs. If the collection fetch failed, fall back to unfiltered recs.
        const allowed = all.length ? new Set(all.map(p => p.handle)) : null;
        const seen = new Set();
        const merged = [];
        // Recs first (most relevant), but only continuing designs
        for (const p of recs) {
          if (String(p.id) === String(pid)) continue;
          if (allowed && !allowed.has(p.handle)) continue;
          if (!seen.has(p.handle)) { merged.push(p); seen.add(p.handle); }
        }
        // Top up from the continuing-design collection (skip duplicates)
        for (const p of all) {
          if (merged.length >= 18) break;
          if (!seen.has(p.handle)) { merged.push(p); seen.add(p.handle); }
        }
        // Cards are server-rendered now; keep vibe carousel population only
        renderVibe(merged.slice(0, 14));
      });
    }

    loadRecs(productId);

    // Hook into color swap to refresh vibe carousel only (recs cards are server-rendered)
    window._bpReloadRecs = function(newProductId) {
      recsSection.setAttribute('data-product-id', newProductId);
      loadRecs(newProductId);
    };
  }

  // ---------- Best Sellers carousel ----------
  const bestSection = document.querySelector('[data-bp-best]');
  if (bestSection) {
    const bestTrack = bestSection.querySelector('[data-bp-best-track]');
    const bestPrev = bestSection.querySelector('[data-bp-best-prev]');
    const bestNext = bestSection.querySelector('[data-bp-best-next]');

    function formatMoneyBest(cents) {
      const amount = (cents / 100).toFixed(2);
      return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function renderBest(products) {
      bestTrack.innerHTML = '';
      products.forEach(p => {
        const a = document.createElement('a');
        a.className = 'bp-recs-card';
        a.href = p.url || ('/products/' + p.handle);
        const imgWrap = document.createElement('div');
        imgWrap.className = 'bp-recs-card-img';
        const img = document.createElement('img');
        img.loading = 'lazy';
        img.alt = p.title || '';
        let src = p.featured_image || (p.images && p.images[0]) || '';
        if (src && typeof src === 'object') src = src.src || '';
        if (src) {
          img.src = src.replace(/(\.(?:jpg|jpeg|png|webp))(\?|$)/i, '_600x$1$2');
          img.srcset = [300, 600, 900].map(w =>
            src.replace(/(\.(?:jpg|jpeg|png|webp))(\?|$)/i, '_' + w + 'x$1$2') + ' ' + w + 'w'
          ).join(', ');
          img.sizes = '(max-width: 900px) 50vw, 16vw';
        }
        imgWrap.appendChild(img);
        const cleanTitle = (p.title || '').split(' Rug')[0].split(' Washable')[0];
        const title = document.createElement('div');
        title.className = 'bp-recs-card-title';
        title.textContent = cleanTitle;
        const price = document.createElement('div');
        price.className = 'bp-recs-card-price';
        const priceCents = (typeof p.price === 'number') ? p.price : (parseFloat(p.price) * 100);
        if (!isNaN(priceCents)) price.textContent = 'From ' + formatMoneyBest(priceCents);
        a.appendChild(imgWrap);
        a.appendChild(title);
        a.appendChild(price);
        bestTrack.appendChild(a);
      });
      updateBestArrows();
    }

    function updateBestArrows() {
      if (!bestPrev || !bestNext) return;
      const maxScroll = bestTrack.scrollWidth - bestTrack.clientWidth;
      bestPrev.disabled = bestTrack.scrollLeft <= 2;
      bestNext.disabled = bestTrack.scrollLeft >= maxScroll - 2;
    }

    function scrollBestByPage(dir) {
      bestTrack.scrollBy({ left: dir * bestTrack.clientWidth * 0.9, behavior: 'smooth' });
    }

    if (bestPrev) bestPrev.addEventListener('click', () => scrollBestByPage(-1));
    if (bestNext) bestNext.addEventListener('click', () => scrollBestByPage(1));
    bestTrack.addEventListener('scroll', () => {
      window.requestAnimationFrame(updateBestArrows);
    }, { passive: true });

    function loadBest() {
      // Try best-sellers collection first, fall back to all products
      fetch('/collections/best-sellers/products.json?limit=20')
        .then(r => r.ok ? r.json() : { products: [] })
        .then(d => (d.products || []))
        .catch(() => [])
        .then(items => {
          if (items.length > 0) return items;
          return fetch('/collections/all/products.json?limit=20')
            .then(r => r.ok ? r.json() : { products: [] })
            .then(d => d.products || [])
            .catch(() => []);
        })
        .then(items => {
          const mapped = items.map(p => ({
            id: p.id,
            title: p.title,
            handle: p.handle,
            featured_image: p.images && p.images[0] && (p.images[0].src || p.images[0]),
            price: p.variants && p.variants[0] ? parseFloat(p.variants[0].price) * 100 : null,
            url: '/products/' + p.handle
          }));
          // Cards are server-rendered now; no-op
        });
    }

    // loadBest(); // disabled — best sellers are server-rendered
  }

  // ---------- Cart drawer (global section handles UI) ----------
  // The drawer markup, styles and core JS live in sections/cart-drawer.liquid.
  // PDP only needs to intercept the add-to-cart form and trigger the drawer.
  const addForm = root.querySelector('[data-bp-form]');
  if (addForm) {
    addForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      // Sold-out variant selected → ATC is hidden; never post to /cart/add
      if (variantInput && !isVariantAvailable(variantInput.value)) return;
      const fd = new FormData(addForm);
      const btn = addForm.querySelector('[data-bp-add]');
      if (btn) btn.disabled = true;
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        });
        const bodyText = await r.clone().text();
        console.log('[bp-cart] /cart/add.js status=' + r.status, bodyText.slice(0, 500));
        if (!r.ok) throw new Error('Add to cart failed: ' + r.status + ' ' + bodyText.slice(0, 200));
        if (window.BloomCart && typeof window.BloomCart.open === 'function') {
          window.BloomCart.open();
        }
      } catch (err) {
        console.error('[bp-cart] add error', err);
        addForm.submit();
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
